import { MessageBar, MessageBarType, ProgressIndicator } from '@fluentui/react';
import * as React from 'react';
import { DropzoneComponent, DropzoneComponentHandlers } from 'react-dropzone-component';
import { getServerHost } from '../lib/helper';

export interface IDropzoneCallbackFunctions {
    sendingCallBack?: (file: any) => void;
    completeCallBack?: (file: any) => void;
    successCallBack?: (file: any) => void;
}

type Props = {
    postUrlPath: string,
    allowMultiple: boolean,
    isReadOnly: boolean;
    params?: any;
    onSuccess: (file: any) => void;
    shouldOpenDialog?: boolean;
};

export const FileUploadControl: React.FC<
    Props
> = (
    { postUrlPath, allowMultiple, isReadOnly, params, onSuccess, shouldOpenDialog, children }
) => {
        
        const [documentsUploading, setDocumentsUploading] = React.useState(false);
        const [error, setError] = React.useState<string | undefined>(undefined);
        const [isDraggingOver, setIsDraggingOver] = React.useState(false);
        let dropzoneRef: any = undefined;


        const _getDjsConfig = (): Dropzone.DropzoneOptions => {
            return {
                headers: {
                    //   ...additionalHeaders
                },
                withCredentials: true,
                addRemoveLinks: false,
                uploadMultiple: allowMultiple,
                createImageThumbnails: false,
                paramName: "files",
                timeout: 1200000,
                params: params
            };
        };

        React.useEffect(() => {
            if (shouldOpenDialog) {
                _openDialog();
            }
        }, [shouldOpenDialog])
    
        const _openDialog = () => {
            if (dropzoneRef) {
                dropzoneRef.dropzone.element.click()
            }
          };

        const _getDragDropComponentConfig = () => {        
            const serverHost = getServerHost();
            return {
                postUrl: `https://${serverHost}`,
                //dropzoneSelector: '.coursework-wrapper'
            };
        };

        const _getDragAndDropEventHandlers = (listViewDropZone: any, errorCallBack: (error: string) => void, callbackFunctions?: IDropzoneCallbackFunctions, uploadLocation?: string): DropzoneComponentHandlers => {
            const completeCallBack = callbackFunctions?.completeCallBack ? callbackFunctions.completeCallBack : () => { };
            //const successCallBack = callbackFunctions?.successCallBack ? callbackFunctions.successCallBack : () => { };
            const sendingCallBack = callbackFunctions?.sendingCallBack ? callbackFunctions.sendingCallBack : () => { };
            let eventHandlers: DropzoneComponentHandlers = {
                init: (dz) => {
                    listViewDropZone = dz;
                },
                processing: (file) => {
                    listViewDropZone.options.url = postUrlPath;
                },
                complete: (file) => {
                    listViewDropZone.removeFile(file);
                    if (listViewDropZone.getUploadingFiles().length === 0 && listViewDropZone.getQueuedFiles().length === 0) {
                        completeCallBack(file);
                    }
                },
                uploadprogress: function(file, progress, bytesSent) {

                },
                success: (file) => {
                    setDocumentsUploading(false);
                },
                dragover: () => {
                    setIsDraggingOver(true)
                },
                dragleave: () => {
                    setIsDraggingOver(false)
                },
                sending: (file, xhr) => {
                    sendingCallBack(file);
                },
                error: (file: File, message: any) => {
                    if (message && message["odata.error"] && message["odata.error"].message && message["odata.error"].message.value) {
                        message = `Error uploading file: '${file.name}' - ${message["odata.error"].message.value}`;
                        _handleDragDropError(message);
                    }
                    else {
                        message = `Error uploading file: '${file.name}' - ${JSON.stringify(message)}`;
                        _handleDragDropError(message);
                    }
                }
            };
            return eventHandlers;
        };

        const _handleDragDropError = (error: string) => {
            setError(error);
            setDocumentsUploading(false);
        };

        const _renderDropzoneSection = () => {
            let listViewDropZone: any;
            let djsConfig: any = _getDjsConfig();
            const callBackFunctions: IDropzoneCallbackFunctions = {
                sendingCallBack: () => {
                    setDocumentsUploading(true);
                },
                completeCallBack: (file) => {
                    onSuccess(file);
                },
                successCallBack: (file) => { },            
            };
            const eventHandlers = _getDragAndDropEventHandlers(
                listViewDropZone,
                _handleDragDropError,
                callBackFunctions
            );

            let el: React.ReactNode = <></>;

            if (isReadOnly) {
                el = children;
            }
            else {
                let cssProperties: React.CSSProperties = isDraggingOver ? { outline: "1px dashed #ccc", opacity: .9 } : {};

                el = <div style={cssProperties}>
                    <DropzoneComponent ref={(node) => { dropzoneRef = node; }} eventHandlers={eventHandlers} djsConfig={djsConfig} config={_getDragDropComponentConfig()}>
                        {children}
                    </DropzoneComponent> </div>;
            }


            return <>
                {documentsUploading && <ProgressIndicator label={`Uploading documents...`} />}
                {error && <MessageBar messageBarType={MessageBarType.error}>{error}</MessageBar>}
                {el}
            </>;
        };

        return <>
            {_renderDropzoneSection()}
        </>;
    };
